import { FormView } from "../FormView";

export function ReportPage() {
  return <FormView formId="remittance" />;
}
